import React from "react";
import * as Sentry from "@sentry/react";
import css from "../../style/thankyou.module.css";

const ThankYou = () => {
  return (
    <div className={css?.thankyouMainDiv}>
      <div className={css?.thankyouCheck}>
        <i class="fa fa-check"></i>
      </div>
      <div className={css?.thankyouHeading}>Thank you!</div>
      <div className={css?.thankyouText}>
        Your booking is confirmed.<br /> A crew will be assigned to your job shortly.<br /> Check your email for the full booking details.
      </div>
    </div>
  );
};

export default ThankYou;
